/* Native Legal policy table of contents: navigation only; policy copy is untouched. */
(() => {
  const initialize = () => {
    const container = document.querySelector('.shopify-policy__container');
    const body = container?.querySelector('.shopify-policy__body');
    const title = container?.querySelector('.shopify-policy__title');
    if (!container || !body || !title || container.querySelector('.yz-policy-toc')) return;
    const headings = Array.from(body.querySelectorAll('h2'))
      .filter(heading => heading.textContent.trim().length);
    if (headings.length < 2) return;

    const aside = document.createElement('aside');
    aside.className = 'yz-policy-toc';
    const details = document.createElement('details');
    const summary = document.createElement('summary');
    summary.textContent = 'On this page';
    const nav = document.createElement('nav');
    nav.setAttribute('aria-label', 'Policy sections');
    const list = document.createElement('ol');
    const links = [];

    for (const [i, heading] of headings.entries()) {
      if (!heading.id) heading.id = 'yz-privacy-section-' + (i + 1);
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = '#' + encodeURIComponent(heading.id);
      link.textContent = heading.textContent.trim();
      item.append(link);
      list.append(item);
      links.push(link);
    }

    nav.append(list);
    details.append(summary, nav);
    aside.append(details);
    container.insertBefore(aside, title);
    container.classList.add('yz-policy-with-toc');

    const compact = window.matchMedia('(max-width: 989px)');
    const onViewportChange = () => { details.open = !compact.matches; };
    onViewportChange();
    if (compact.addEventListener) compact.addEventListener('change', onViewportChange);
    else compact.addListener(onViewportChange);
    summary.addEventListener('click', (event) => {
      if (!compact.matches) event.preventDefault();
    });

    let pending = false;
    const markSection = () => {
      pending = false;
      let index = 0;
      for (let i = 0; i < headings.length; i += 1) {
        if (headings[i].getBoundingClientRect().top <= 150) index = i;
      }
      for (let i = 0; i < links.length; i += 1) {
        if (i === index) links[i].setAttribute('aria-current', 'location');
        else links[i].removeAttribute('aria-current');
      }
    };
    const scheduleUpdate = () => {
      if (!pending) {
        pending = true;
        window.requestAnimationFrame(markSection);
      }
    };
    window.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate, { passive: true });
    markSection();
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else initialize();
})();
